import React, { FC, useEffect, useRef, useState } from 'react';

import clsx from 'clsx';

import { isInViewport } from '@utils/dom';
import { isValueSet } from '@utils/guards';

import { ChevronUpIcon } from '@components/icons/ChevronUpIcon';

import styles from './ScrollToTopButton.module.scss';

const minScrollPosition = 100;

export const ScrollToTopButton: FC = () => {
    const [isVisible, setVisible] = useState(false);
    const lastPosition = useRef<number>(0);

    const handleClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
        const footerElement = document.querySelector('[data-footer]');

        const listener = () => {
            const shouldShowButton =
                window.scrollY < lastPosition.current && window.scrollY > minScrollPosition;

            // Проверка, виден ли верхний край футера во вьюпорте.
            if (isValueSet(footerElement)) {
                const hasFooterInViewport = isInViewport(footerElement);
                setVisible(shouldShowButton && !hasFooterInViewport);
            } else {
                setVisible(shouldShowButton);
            }
            lastPosition.current = window.scrollY;
        };

        window.addEventListener('scroll', listener);
        return () => {
            window.removeEventListener('scroll', listener);
        };
    }, []);

    return (
        <button
            type="button"
            className={clsx(styles.root, !isVisible && styles.isHidden)}
            onClick={handleClick}
        >
            <ChevronUpIcon className={styles.icon} />
        </button>
    );
};
